/* eslint-disable import/prefer-default-export */
export const isNowPage = pathname => pathname.includes('/now');
